import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { getRecentLedmodules, removeRecentLedmodule, clearRecentLedmodules } from '../../../utils/recentLedmodulesUtility';
import { Link } from 'react-router-dom';
import { Edit, Done, DeleteForever } from '@material-ui/icons';
import moment from 'moment';

export default class RecentLedmodules extends React.Component {

    constructor() {
        super();

        this.state = {
            recentLedmodules: []
        };
    }

    componentDidMount() {

        this.setState((state) => {
            const recentLedmodules = Object.values(getRecentLedmodules());
            recentLedmodules.sort(function (a, b) { return a.updateDate > b.updateDate });

            return {
                'recentLedmodules': recentLedmodules
            };
        });
    }

    removeLedmodule(ledmodule) {
        this.setState((state) => {
            const recentLedmodules = Object.values(removeRecentLedmodule(ledmodule.id));
            recentLedmodules.sort(function (a, b) { return a.updateDate > b.updateDate });

            return {
                'recentLedmodules': recentLedmodules
            };
        });
    }

    clearLedmodules() {
        this.setState((state) => {
            const recentLedmodules = Object.values(clearRecentLedmodules());
            recentLedmodules.sort(function (a, b) { return a.updateDate > b.updateDate });

            return {
                'recentLedmodules': recentLedmodules
            };
        });
    }

    renderList() {

        // if (this.state.recentLedmodules.length === 0 ){
        //     return <span>No recent ledmodules</span>
        // }

        return this.state.recentLedmodules.map(ledmodule => {

            const infoUrl = `/ledmodules/${ledmodule.id}/info`;

            const doneText = ledmodule.done
                ? <Done style={{ color: "#34A853", fontSize: "1.25rem" }} />
                : <Edit style={{ fontSize: "1.25rem" }} />;

            return (
                <tr key={ledmodule.id} style={{ textAlign: "center" }}>
                    <td style={{ padding: "0.25rem" }}>
                        {doneText}
                    </td>
                    <td>
                        <Link to={infoUrl} className="a-cloud-list">
                            {ledmodule.name}
                        </Link>
                    </td>
                    {/* <td>
                        {moment(ledmodule.creationDate).format('DD/MM/YYYY HH:mm')}
                    </td> */}
                    <td>
                        {moment(ledmodule.updateDate).format('DD/MM/YYYY HH:mm')}
                    </td>
                    <td style={{ padding: "0.25rem" }}>
                        <DeleteForever className="delete-recent-ledmodule" style={{ cursor: "pointer", color: "black", fontSize: "1.25rem" }} onClick={(e) => this.removeLedmodule(ledmodule)} />
                    </td>
                </tr>
            );
        });
    }

    render() {

        const clearAllElement = this.state.recentLedmodules.length > 0
            ? <div style={{ marginBottom: '0', float: 'right', cursor: 'pointer', maxHeight: '19px' }} onClick={(e) => this.clearLedmodules()} >Clear all</div>
            : null;
        return (
            <Card className="card-recent-ledmodules" >
                <div className='card-header-recent-ledmodule'>
                    <h6 style={{ marginBottom: '0', float: 'left' }}>Recent Ledmodules</h6>
                    {clearAllElement}
                </div>
                <Card.Body style={{ padding: '0', height: '100%', maxHeight: "83.5vh" }}>
                    <Table responsive striped bordered hover size="sm" style={{ marginBottom: '0' }}>
                        <thead>
                            <tr style={{ textAlign: "center" }}>
                                <th style={{ width: "5rem" }}>Status</th>
                                <th>Ledmodule Name</th>
                                {/* <th>Creation Date</th> */}
                                <th>Update Date</th>
                                <th style={{ width: '1.5em' }}></th>
                            </tr>
                        </thead>
                        <tbody className="tbody-ledmodule-cloud-list">
                            {this.renderList()}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        );
    }
}